import { IUser } from "../types/User";

export enum GtmEvent {
  PageView = "page_view",
  ButtonClick = "button_click",
  SubmitForm = "submit_form",
}

export interface ButtonClickEvent {
  event: GtmEvent.ButtonClick;
  page: string;
  button: string;
  [key: string]: string | number | IUser | null;
}

export interface PageViewEvent {
  event: GtmEvent.PageView;
  page_path: string;
}

export interface SubmitFormEvent {
  event: GtmEvent.SubmitForm;
  form: string;
}
